
    import '/mnt/src/components/Textarea/index.md?watch=parent';
    export const demoIndex = {
  ids: ["textarea-demo-demo1"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Textarea/index.md?type=demo')
};